import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Grid } from '@material-ui/core';
import { history } from '../helpers/history';
import Dashboard from '../components/Menu/Dashboard';
import LoadingScreen from '../components/Complements/LoadingScreen';
import Title from './../components/Complements/Title';
import StepperQuestions from '../components/Questions/StepperQuestions'
import formValidation from "../helpers/formValidation"
import { getQuestions } from "../actions/questions";
import { createQuestionsByUser, findQuestionsByUser } from "../actions/userquestions";
import { responseQuestion } from "../actions/loginUser";
import { feathersCreateData } from '../services';
import DialogOTP from '../components/Complements/DialogOTP';
import { sendLogs } from '../functions/function-logs';
import { changeStatusUser } from './../actions/codes'
import { sendEmail } from "./../actions/sendemail";
import { validateIp } from '../functions/store';
import {encrypt} from './../functions/mobile';

const QuestionsContainer = props => {

    const { handleOpenSnack, getDeviceData, updateIpDevice, devices } = props
    const [ dataQuestions, setDataQuestions ] = useState([])
    const [ dataQuestionsSelected, setDataQuestionsSelected ] = useState([])
    const [ question, setQuestion ] = useState(0)
    const [ answer, setAnswer ] = useState("")
    const [ type, setType ] = useState("text")
    const [ activeStep, setActiveStep ] = useState(0)
    const [ loading, setLoading ] = useState(false)
    const [ flagHaveQuestionsUser, setFlagHaveQuestionsUser ] = useState(false)
    const [ formErrors, setFormErrors ] = useState({})
    const [ openDialogOTP, setOpenDialogOTP ] = useState(false);
    const [ initialTime, setInitialTime ] = useState(Date.now());

    const mount = () => {
        const unmount = () => {
            handleGetDataQuetions()
        }
        return unmount()
    }

    useEffect(mount, []) 

    const handleGetDataQuetions = () => {

        setLoading(true)

        getQuestions().payload.then(
            response => {
                //console.log(response)
                const { data } = response;
                setDataQuestions(data)
                handleGetDataByIdentificationUser(data)
            }
        ).catch(
            error => {
                //console.log(error)
                handleOpenSnack("Ha ocurrido un error al obtener las preguntas. Por favor vuelva a intentar.", "error")
                setLoading(false)
            }
        )
    }

    const handleGetDataByIdentificationUser = (arrayquestions) => {
      findQuestionsByUser({
        state: 1,
      })
        .payload.then((response) => {
          let newArray = [];
          if (response.data) newArray = response.data.filter((item) => item.state === 1);
           
          newArray.length === 0
            ? getDataQuestions()
            : convertDataQuestions(newArray, arrayquestions);
        })
        .catch((error) => {
          handleOpenSnack(
            "Ha ocurrido un error al obtener las preguntas registradas del cliente. Por favor vuelva a intentar.",
            "error"
          );
          setLoading(false);
        });
    };

    const convertDataQuestions = (data, arrayallquestions) => {

        try {

            setType("password")
            let arrayQuestions = []
    
            setQuestion(data[0].question)
            setAnswer("")
            setFlagHaveQuestionsUser(true)
    
            for(let i = 0; i < data.length; i++){
                let objectSave = {
                    title : "Pregunta "+(i+1),
                    question : data[i].question,
                    answer : "",
                    id : data[i].id
                }
    
                getPositionQuestionById(arrayallquestions, data[i].question, 0)
    
                arrayQuestions.push(objectSave)
            }
    
            setDataQuestionsSelected(arrayQuestions)
            setLoading(false)
        }catch(error) {
            handleOpenSnack("Ha ocurrido un error al obtener las preguntas registradas. Por favor llámenos al 0958882285 para revisión del inconveniente.", "error")
        }

    }

    const getDataQuestions = () => {

        setType("text")

        let arrayQuestions = []

        for(let i = 0; i < 3; i++){
            let objectSave = {
                title : "Pregunta "+(i+1),
                question : 0,
                answer : "",
                id : i
            }

            arrayQuestions.push(objectSave)
        }

        setDataQuestionsSelected(arrayQuestions)
        setLoading(false)
    }

    const handleSubmit = async(values) => {
        //console.log(values)
        setLoading(true)
        if(question !== 0){
    
            const responseSearchQuestions = (question !== dataQuestionsSelected[activeStep].question) ? dataQuestionsSelected.filter(item => item.question === question) : []
    
            if(responseSearchQuestions.length === 0){
                if(question !== dataQuestionsSelected[activeStep].question){
                    getPositionQuestionById(dataQuestions, dataQuestionsSelected[activeStep].question, 1)
                    getPositionQuestionById(dataQuestions, question, 0)
                }
                const dataQuestionsSelectedAux = dataQuestionsSelected;
                dataQuestionsSelected[activeStep].question = question;
                dataQuestionsSelected[activeStep].answer = answer.toUpperCase();
                setDataQuestionsSelected(dataQuestionsSelectedAux)
    
                if(activeStep < 2){
                    if(dataQuestionsSelected[activeStep + 1].answer.length > 0){
                        setAnswer(dataQuestionsSelected[activeStep + 1].answer)
                        setQuestion(dataQuestionsSelected[activeStep + 1].question)
                    }else{
                        setAnswer("")
                        setQuestion(0)
                    }
                }
                setActiveStep(activeStep+1)
            }else{
                handleOpenSnack("La pregunta ya ha sido seleccionada. Por favor seleccione una pregunta diferente.", "info")
            }
    
            //console.log("ActiveStep: ", activeStep)
    
            if((activeStep >= 2) && (responseSearchQuestions.length === 0)){
                //console.log(user)
                //console.log(dataQuestionsSelected)
                const { ip } = devices
                let ipSend = await validateIp(ip, getDeviceData, updateIpDevice)
                handleGenerateOtp(ipSend)
            }else{
                setLoading(false)
            }
        }else{
            setLoading(false)
            handleOpenSnack("Debe seleccionar una pregunta.", "info")
        }

    }

    const handleCompareCodeOtp = async(valuesFormOtp) => {

        try {
            
            setLoading(true)

            const {ip, device, mac} = devices

            const sendData = encrypt(JSON.stringify({
                ip,
                mac,
                device,
                type : 24,
                inputOtp : valuesFormOtp.data
            }))
            
            const responseValidateCode = await feathersCreateData("code-validation", { sendData })()

            //console.log("Respuesta: ", responseValidateCode)

            //const responseValidateCodeDecrypt = JSON.parse(decrypt(responseValidateCode.responseData))

            const sendDataQuestions = dataQuestionsSelected.map( (item) => {
                return {
                    ...item,
                    answer : encrypt(item.answer)
                }
            })

            const { error, message, type, viewDialogOtp } = responseValidateCode;

            if (error === false) {
        
                    createQuestionsByUser({
                        action : (flagHaveQuestionsUser === false) ? encrypt("create") : encrypt("update"),
                        questions : sendDataQuestions,
                        device : encrypt(JSON.stringify({
                            os : device,
                            ip,
                            mac,
                            type : 24
                        })),
                        otp : encrypt(valuesFormOtp.data)
                    }).payload.then(
                        response => {
                            
                            //console.log(response)
        
                            const { message, type, error } = response
                            
                            handleOpenSnack(message, type)
        
                            setLoading(false)
        
                            if(error === false){
        
                                props.responseQuestion(1)
                                history.push("/")
                                
                            }
                            
                        }
                    ).catch(
                        error => {
                            //console.log(error)
                            handleOpenSnack("Ha ocurrido un error al obtener las preguntas. Por favor vuelva a intentar.", "error")
                            setLoading(false)
                        }
                    )
            }else{
                if(viewDialogOtp === false){
                    setOpenDialogOTP(false)
                }
                setLoading(false)
                handleOpenSnack(message, type);
            }
        } catch (error) {
            //console.log(error)
            setLoading(false)
            handleOpenSnack("Ha ocurrido un error al obtener las preguntas. Por favor vuelva a intentar.", "error")
        }

    }

    const handleGenerateOtp = () => {
        
        try {
            
            setLoading(true)

            const { ip, device, mac } = devices;

            const sendData = encrypt(JSON.stringify({emited: 'NAVCREATECODE', type: 24, deviceData: device, ip, mac }))
            feathersCreateData('codes-recovery',{ sendData } )()
                    .then((res) => {
                        
                        setOpenDialogOTP(true)
                        setInitialTime(Date.now())
                        
                        setLoading(false)
                    }).catch(err => {
                        //console.log(err)
                        setLoading(false)
                        handleOpenSnack('No se ha podido realizar la transacción. Por favor intente nuevamente', 'error')
                    })

        } catch (error) {
            setLoading(false)
            handleOpenSnack('No se ha podido realizar la transacción. Por favor intente nuevamente', 'error')
        }
    }

    const getPositionQuestionById = (arrayquestions, id, state) => {

        let dataQuestionsAux = arrayquestions

        //console.log(arrayquestions)

        for(let i = 0; i < arrayquestions.length; i++){
            if(arrayquestions[i].id === id){
                dataQuestionsAux[i].state = state;
            }
        }

        setDataQuestions(dataQuestionsAux)
    }

    const handleChangeQuestion = (data) => {

        if(data !== 0){
            const dataFilterQuestion = (data !== dataQuestionsSelected[activeStep].question) ? dataQuestionsSelected.filter(item => item.question === data) : [];
    
            if(dataFilterQuestion.length === 0){
                setQuestion(data)
            }else{
                handleOpenSnack("La pregunta ya ha sido seleccionada. Por favor seleccione una pregunta diferente.", "info")
            }
        }else{
            handleOpenSnack("Debe seleccionar una pregunta.", "info")
        }
        
    }

    const handleChangeAnswer = (value) => {
        //console.log(value)
        const error = formValidation("text", 1, 50, value) || ""
        setFormErrors({
            answer: error
        })
        setAnswer(value)
    }

    const handleCloseDialogOTP = () => {
        setOpenDialogOTP(false)
        //this.setState({ openDialogOTP: false })
    };

    const handleChangeInputOtp = (valueinput) => {
        if(valueinput.target.value.toString().length === 4){
            // console.log("VALUE OTP: ", valueinput)
            handleCompareCodeOtp({data : valueinput.target.value.toString()});
        }

    }

    const handleBackQuestions = () => {
        //console.log("Respuesta anterior: ", dataQuestionsSelected[activeStep - 1].answer)
        setQuestion(dataQuestionsSelected[activeStep - 1].question)
        setAnswer(dataQuestionsSelected[activeStep - 1].answer)
        setActiveStep(activeStep - 1)
    }

    const renderBody = () => {
        return <div>
            <Grid container spacing={3}>
                <Grid item xs={12} md={12} lg = {12} sm = {12}>
                    <Title>Preguntas de Seguridad</Title>
                </Grid>
                <Grid item xs={12} md={12} lg = {12} sm = {12}>
                    <StepperQuestions
                        activeStep = {activeStep}
                        steps = {dataQuestionsSelected}
                        orientation = {"vertical"}
                        handleNext = {handleSubmit}
                        question = {question}
                        dataquestions = {dataQuestions}
                        handleChangeQuestion = {handleChangeQuestion}
                        handleChangeAnswer = {handleChangeAnswer}
                        answer = {answer}
                        handleBack = {handleBackQuestions}
                        formErrors = {formErrors}
                        type = { type }
                        setType = { setType }
                    />
                </Grid>
            </Grid>
            <DialogOTP
                    openDialogOTP = {openDialogOTP}
                    loading = { loading }
                    initialTime = {initialTime}
                    showQR = {false}
                    onCloseDialogOTP = { handleCloseDialogOTP }
                    onKeyPress = { handleChangeInputOtp }
                    OTPSubmit = { handleCompareCodeOtp }
                />
        </div>
    } 

    return (
        <div>
            <Dashboard
                title= ""
                body = { renderBody() }
                multiple = { false }
            />
            <LoadingScreen open={loading} />
            
        </div>
    );

}

export default connect(null, {QuestionsContainer, createQuestionsByUser, responseQuestion, findQuestionsByUser, sendLogs, changeStatusUser, sendEmail} )(QuestionsContainer);